// Inspired by https://wiki.base22.com/btg/creating-a-fancy-message-using-console-log-116722335.html
import { oneHopeLogo } from '../../../../server/asciiArt';

const purple = '#784CAB';
const purpleText = `color:${purple};font:Monaco;`;
const purpleBoldText = `${purpleText}font-weight:bold;`;

const createConsoleInfoMessageTextFromString = (formatting: string) => (
  str: string,
) => {
  const lineSplit = str.split('\n');
  const lineLength = lineSplit.length;
  const lineFormatted = `\n%c${lineSplit.join('\n%c')}`;
  const textFormatting = Array(lineLength).fill(formatting);
  console.info(lineFormatted, ...textFormatting);
};

const recruitingMessage = `You must be the engineer we've been looking for since you found our secret message! Apply now to work on our cutting edge tech stack React, Relay Modern, GraphQL, TypeScript, NodeJS, Cassandra, CircleCI, AWS, Jest, and Cypress: https://onehope.applytojob.com/`;

export default function onehopeAscii() {
  [oneHopeLogo].forEach(createConsoleInfoMessageTextFromString(purpleBoldText));
  [recruitingMessage].forEach(
    createConsoleInfoMessageTextFromString(purpleText),
  );
}
